<template>
   <div class="w-full">
    <div class=" bg-gray-200 py-3 flex px-2  overflow-x-auto">
      <div
      class="mt-3 ball"
        v-for="(item, index) in flowItem"
        :key="index"
        :class="isClass(index)"
      >
        <i></i>
        <abbr></abbr>
        <!-- <p class="uppercase label md:inline-block hidden">{{ activeAction }}</p> -->
        <p class="uppercase label md:inline-block hidden"></p> 
        <span class="inline-block pt-4 name-label title">
          <b class="capitalize">{{ item ? item.activityType : '-' }}</b>
          <span class="block w-full">{{ item ? getDate(item.createdAt, 'date') : '-' }}</span>
          <span class="opacity-50">{{ item ? getDate(item.createdAt, 'time') : '-' }}</span>
        </span>
      </div>
    </div>
   </div>
  </template>
  
  <script>
  import moment from "moment"

  export default {
    props: ["index", 'timelines'],
    data() {
      return {
        flowItem: []
      };
    },
    watch: {
      timelines(val){
        this.flowItem = val
      }
    },
    computed: {
      routeId() {
        return this.flowItem.length - 1;
      },
      activeAction(){
        return this.flowItem[this.flowItem.length - 1]?.activityType || ''
      }
    },
    mounted() {
      this.flowItem = this.timelines
    },
    methods: {
      getDate(time, type){
        switch (type) {
          case 'date':
          return moment(time).format("YYYY/MM/DD")
        
         case 'time':
         return moment(time).format("hh:mm:ss")
        }
      },
      isClass(val) {
        let classes;
        if (Number(this.routeId) > val) {
          classes = "pass-flow-item ";
        } else if (Number(this.routeId) == val) {
          classes = "active-flow-item";
        } else if (Number(this.routeId) < val) {
          classes = "flow-item";
        } else{
            classes = "flow-item";
        }
  
        return classes;
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .name-label{
    position: relative;
    font-size: 12px
  }
  .flow-item {
    border-top: 3px dashed #878a8d;
    width: 18%;
    position: relative;
    min-width: 70px;
    i {
      position: absolute;
      display: inline-block;
      width: 50%;
      height: 12px;
      top: -6.5px;
      border-radius: 50px;
      @apply bg-transparent;
    }
    p{
        display: none;
    }
    abbr {
      position: absolute;
      display: inline-block;
      width: 100%;
      height: 3px;
      top: -3px;
      border-radius: 50px;
      @apply bg-transparent;
    }
    &::after {
      content: "";
      position: absolute;
      display: block;
      left: 0px;
      border-radius: 50%;
      border: 2px solid #878a8d;
      top: calc(0% - 12px);
      height: 20px;
      width: 20px;
      background: white;
      transition: 300ms;
    }
    &::before {
      content: "";
      position: absolute;
      display: block;
      left: 5px;
      z-index: 2;
      border-radius: 50%;
      border: 1.5px solid #c8ccd0;
      top: calc(0% - 7px);
      height: 10px;
      width: 10px;
      background: white;
      transition: 300ms;
    }
  }
  .active-flow-item {
    border-top: 3px dashed #878a8d;
    width: 18%;
    position: relative;
    min-width: 70px;
    i {
      position: absolute;
      display: inline-block;
      width: 70px;
      height: 16px;
      top: -8.5px;
      border-radius: 50px;
      @apply bg-primary-yellow;
      transition: 300ms;
    }
    p{
        position: absolute;
        z-index: 10;
        left: 45px;
        top: -7px;
        font-size: 9px;
        font-weight:  600;
        color: white
    }
    abbr {
      position: absolute;
      display: inline-block;
      width: 100%;
      height: 3px;
      top: -3px;
      border-radius: 50px;
      @apply bg-transparent;
      transition: 300ms;
    }
    &::after {
      content: "";
      position: absolute;
      display: block;
      left: 0px;
      border-radius: 50%;
      border: 2px solid #fcc210;
      top: calc(0% - 20px);
      height: 40px;
      width: 40px;
      @apply bg-primary-yellow;
      transition: 300ms;
    }
    &::before {
      content: "";
      position: absolute;
      display: block;
      left: 9px;
      z-index: 2;
      border-radius: 50%;
      border: 1.5px solid transparent;
      top: calc(0% - 11px);
      height: 22px;
      width: 22px;
      background: white;
      transition: 300ms;
    }
  }
  
  .pass-flow-item {
    border-top: 3px dashed #878a8d;
    width: 18%;
    position: relative;
    min-width: 70px;
    i {
      position: absolute;
      display: inline-block;
      width: 50%;
      height: 12px;
      top: -6.5px;
      border-radius: 50px;
      @apply bg-transparent;
      transition: 300ms;
    }
    p{
        display: none;
    }
    abbr {
      position: absolute;
      display: inline-block;
      width: 100%;
      height: 3px;
      top: -3px;
      border-radius: 50px;
      @apply  bg-primary-yellow;
      transition: 300ms;
    }
    &::after {
      content: "";
      position: absolute;
      display: block;
      left: 0px;
      border-radius: 50%;
      border: 2px solid #FCC210;
      top: calc(0% - 12px);
      height: 20px;
      width: 20px;
      @apply  bg-primary-yellow;
      transition: 300ms;
    }
    &::before {
      content: "";
      position: absolute;
      display: block;
      left: 5px;
      z-index: 2;
      border-radius: 50%;
      border: 1.5px solid transparent;
      top: calc(0% - 7px);
      height: 10px;
      width: 10px;
      background: white;
      transition: 300ms;
    }
  }
  
  .flow-item:nth-last-child(1),
  .active-flow-item:nth-last-child(1),
  .pass-flow-item:nth-last-child(1) {
    width: 10px;
  }
   @media screen and (max-width: 476px) {
    .title{
      font-size: 10px;
    }
   }
   @media screen and (min-width: 476px) {
    .label{
      font-size: 8px;
    }
   }
   .ball:nth-of-type(6)>span{
      position: relative;
      left: -100%
   }
  </style>
  